/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CurrentUserFboLocationsResponse } from '../../models/current-user-fbo-locations-response';

export interface GetCurrentUserFboLocations$Params {
}

export function getCurrentUserFboLocations(http: HttpClient, rootUrl: string, params?: GetCurrentUserFboLocations$Params, context?: HttpContext): Observable<StrictHttpResponse<CurrentUserFboLocationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getCurrentUserFboLocations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CurrentUserFboLocationsResponse>;
    })
  );
}

getCurrentUserFboLocations.PATH = '/api/me/fbo-locations';
